import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CakeItEasyWebUiModule } from '@cakeiteasy/web-ui';
import { NgCakeItEasyUtilsModule } from '@cakeiteasy/web-utils';
import { TranslateModule } from '@ngx-translate/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PaymentModule } from '@cakeiteasy/order-process';

import { UiModule } from '../ui/ui.module';

import { FaqFormComponent } from './components/faq-form/faq-form.component';
import { ContactUsFormComponent } from './components/contact-us-form/contact-us-form.component';
import { ReportMissingBakeryFormComponent } from './components/report-missin-bakery-form/report-missing-bakery-form.component';

const COMPONENTS = [
  FaqFormComponent,
  ContactUsFormComponent,
  ReportMissingBakeryFormComponent,
];

@NgModule({
  imports: [
    UiModule,
    NgbModule,
    FormsModule,
    CommonModule,
    PaymentModule,
    TranslateModule,
    ReactiveFormsModule,
    CakeItEasyWebUiModule,
    NgCakeItEasyUtilsModule,
  ],
  exports: [
    ...COMPONENTS,
  ],
  declarations: [
    ...COMPONENTS,
  ]
})
export class UsersUiModule {
}
